import React from "react"
import ResourcesContainer from "@geome/react-components/lib/containers/resources"
import connectToFlux from "@geome/react-next/lib/connectToFlux"

const shouldRefresh = (props) => {
  return props.bounds != null
}

const useDrivingDistances = (props) => {
  return !!props.selectedPlace
}

const getReferencePoint = (props) => {
  return (props.selectedPlace && props.selectedPlace.origin) || props.mapCenter
}

const changeConstraints = (constraints, props) => {
  return {
    ...constraints,
    ...props.directionsOptions,
    origin: getReferencePoint(props),
    channel: props.channel,
    selected: props.selectedLocation,
  }
}

const changeMetadata = (metadata, props) => {
  return {
    ...metadata,
    referencePoint: getReferencePoint(props),
  }
}

const Resources = (props) => (
  <ResourcesContainer
    {...props}
    changeConstraints={(constraints) => changeConstraints(constraints, props)}
    changeMetadata={(metadata) => changeMetadata(metadata, props)}
    shouldRefresh={() => shouldRefresh(props)}
  />
)

const queries = {
  bounds: "map.geometry.bounds",
  selectedPlace: "search.selectedPlace",
  mapCenter: "map.geometry.offsetCenter",
  channel: "config.gApiSettings.channel",
  selectedLocation: "locations.selected",
}

export default connectToFlux(queries, {})(Resources)
